import { finalizationApplication } from 'commons/service/bank/application'
import { WriteHook, useMutationManager } from 'state-manager'

const useApplicationFinalization: WriteHook<{ applicationId: number }, unknown> = (opts) =>
  useMutationManager<{ applicationId: number }, unknown>(finalizationApplication, opts)

export default useApplicationFinalization
